module.exports = __webpack_public_path__ + "1a1aa37c54bdecbe88c67405cb4a8ab3.png";